import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "header-icon" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "tab-header" }
const _hoisted_6 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_7 = {
  key: 0,
  class: "modal-body loading-state"
}
const _hoisted_8 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_9 = {
  key: 0,
  class: "content-layout"
}
const _hoisted_10 = { class: "list-panel" }
const _hoisted_11 = { class: "list-header" }
const _hoisted_12 = { class: "count" }
const _hoisted_13 = { class: "request-list" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "row-main" }
const _hoisted_16 = { class: "row-ym" }
const _hoisted_17 = { class: "row-type" }
const _hoisted_18 = { class: "row-sub" }
const _hoisted_19 = { class: "row-date" }
const _hoisted_20 = { class: "row-tags" }
const _hoisted_21 = {
  key: 0,
  class: "tag new"
}
const _hoisted_22 = {
  key: 1,
  class: "tag resigned"
}
const _hoisted_23 = { class: "detail-panel" }
const _hoisted_24 = { class: "detail-section" }
const _hoisted_25 = { class: "detail-grid" }
const _hoisted_26 = { class: "detail-item" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "detail-item" }
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "detail-item" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = {
  key: 0,
  class: "detail-item full"
}
const _hoisted_33 = { class: "emp-chips" }
const _hoisted_34 = {
  key: 1,
  class: "detail-item full"
}
const _hoisted_35 = { class: "emp-chips" }
const _hoisted_36 = {
  key: 2,
  class: "detail-item full"
}
const _hoisted_37 = { class: "memo-box" }
const _hoisted_38 = { class: "process-section" }
const _hoisted_39 = { class: "process-notice" }
const _hoisted_40 = { class: "process-actions" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 1,
  class: "no-selection"
}
const _hoisted_44 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_45 = {
  key: 2,
  class: "modal-body"
}
const _hoisted_46 = {
  key: 0,
  class: "content-layout"
}
const _hoisted_47 = { class: "list-panel" }
const _hoisted_48 = { class: "list-header" }
const _hoisted_49 = { class: "count" }
const _hoisted_50 = { class: "request-list" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "row-main" }
const _hoisted_53 = { class: "row-ym" }
const _hoisted_54 = { class: "row-sub" }
const _hoisted_55 = { class: "row-date" }
const _hoisted_56 = { class: "row-tags" }
const _hoisted_57 = {
  key: 0,
  class: "tag new"
}
const _hoisted_58 = {
  key: 1,
  class: "tag resigned"
}
const _hoisted_59 = { class: "detail-panel" }
const _hoisted_60 = { class: "detail-section" }
const _hoisted_61 = { class: "detail-grid" }
const _hoisted_62 = { class: "detail-item" }
const _hoisted_63 = { class: "value" }
const _hoisted_64 = { class: "detail-item" }
const _hoisted_65 = { class: "value" }
const _hoisted_66 = { class: "detail-item" }
const _hoisted_67 = { class: "value" }
const _hoisted_68 = {
  key: 0,
  class: "detail-item full"
}
const _hoisted_69 = { class: "emp-chips" }
const _hoisted_70 = {
  key: 1,
  class: "detail-item full"
}
const _hoisted_71 = { class: "emp-chips" }
const _hoisted_72 = {
  key: 2,
  class: "detail-item full"
}
const _hoisted_73 = { class: "memo-box" }
const _hoisted_74 = { class: "result-header" }
const _hoisted_75 = { class: "result-grid" }
const _hoisted_76 = { class: "result-item" }
const _hoisted_77 = { class: "value" }
const _hoisted_78 = { class: "result-item" }
const _hoisted_79 = { class: "value" }
const _hoisted_80 = {
  key: 0,
  class: "result-item full"
}
const _hoisted_81 = { class: "label" }
const _hoisted_82 = {
  key: 1,
  class: "no-selection"
}
const _hoisted_83 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_84 = { class: "modal-footer" }
const _hoisted_85 = ["disabled"]

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

interface WageTaxRequest {
  wtr_idx: number;
  m_sisul_code: string;
  wtr_leb_ym: string;
  wtr_type: string;
  wtr_status: string;
  wtr_new_employees?: string;
  wtr_resigned_employees?: string;
  wtr_request_memo?: string;
  wtr_requested_by?: string;
  wtr_requested_at?: string;
  wtr_cancelled_by?: string;
  wtr_cancelled_at?: string;
  wtr_cancel_reason?: string;
  wtr_result_memo?: string;
  wtr_processed_by?: string;
  wtr_processed_at?: string;
  m_sisul_name?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WageTaxRes',
  props: {
    modelValue: { type: Boolean },
    sisulCode: {},
    sisulName: {}
  },
  emits: ["update:modelValue", "processed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

// 상태
const isLoading = ref(false);
const isProcessing = ref(false);
const processAction = ref('');
const activeTab = ref<'pending' | 'history'>('pending');
const pendingRequests = ref<WageTaxRequest[]>([]);
const historyRequests = ref<WageTaxRequest[]>([]);
const selectedRequest = ref<WageTaxRequest | null>(null);
const selectedHistoryRequest = ref<WageTaxRequest | null>(null);
const resultMemo = ref('');

// JSON 파싱 헬퍼
const getParsedEmployees = (json?: string) => {
  if (!json) return [];
  try {
    return JSON.parse(json);
  } catch {
    return [];
  }
};

// 상태 클래스
const getStatusClass = (status: string) => {
  switch (status) {
    case '승인': return 'approved';
    case '미승인': return 'rejected';
    case '취소': return 'cancelled';
    default: return '';
  }
};

// 날짜 포맷
const formatDateTime = (datetime?: string) => {
  if (!datetime) return '-';
  const d = new Date(datetime);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

const formatYearMonth = (ym?: string) => {
  if (!ym || ym.length !== 6) return ym || '';
  return `${ym.substring(0, 4)}.${ym.substring(4, 6)}`;
};

// 요청 선택 (대기중)
const selectRequest = (request: WageTaxRequest) => {
  selectedRequest.value = request;
  resultMemo.value = '';
};

// 처리내역 선택
const selectHistoryRequest = (request: WageTaxRequest) => {
  selectedHistoryRequest.value = request;
};

// 상태 아이콘
const getStatusIcon = (status: string) => {
  switch (status) {
    case '승인': return 'mdi-check-circle';
    case '미승인': return 'mdi-close-circle';
    case '취소': return 'mdi-cancel';
    default: return 'mdi-help-circle';
  }
};

// 상태 아이콘 색상
const getStatusIconColor = (status: string) => {
  switch (status) {
    case '승인': return '#10b981';
    case '미승인': return '#ef4444';
    case '취소': return '#6b7280';
    default: return '#9ca3af';
  }
};

// 데이터 로드
const loadRequests = async () => {
  if (!props.sisulCode) return;

  isLoading.value = true;
  try {
    // 대기중 요청
    const pendingRes = await axios.get('/api/wage-process/tax-request/list', {
      params: { sisulCode: props.sisulCode, status: '요청' }
    });
    if (pendingRes.data.success) {
      pendingRequests.value = pendingRes.data.data || [];
    }

    // 처리 내역 (승인, 미승인, 취소)
    const historyRes = await axios.get('/api/wage-process/tax-request/list', {
      params: { sisulCode: props.sisulCode }
    });
    if (historyRes.data.success) {
      historyRequests.value = (historyRes.data.data || []).filter(
        (r: WageTaxRequest) => r.wtr_status !== '요청'
      );
    }

    selectedRequest.value = null;
    selectedHistoryRequest.value = null;
  } catch (error) {
    console.error('요청 목록 로드 오류:', error);
  } finally {
    isLoading.value = false;
  }
};

// 요청 처리
const handleProcess = async (status: '승인' | '미승인') => {
  if (!selectedRequest.value) return;

  if (status === '미승인' && !resultMemo.value.trim()) {
    store.commit('showSnackbar', {
      text: '미승인 사유를 입력해주세요.',
      color: 'warning'
    });
    return;
  }

  const user = store.state.user;
  isProcessing.value = true;
  processAction.value = status;

  try {
    const response = await axios.post('/api/wage-process/tax-request/process', {
      wtrIdx: selectedRequest.value.wtr_idx,
      status,
      resultMemo: resultMemo.value,
      processedBy: user?.m_id || 'admin'
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: `요청이 ${status}되었습니다.`,
        color: 'success'
      });
      emit('processed');
      await loadRequests();
    } else {
      throw new Error(response.data.message || '처리 실패');
    }
  } catch (error: any) {
    console.error('요청 처리 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '처리 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isProcessing.value = false;
    processAction.value = '';
  }
};

// 닫기
const handleClose = () => {
  dialogVisible.value = false;
  selectedRequest.value = null;
  selectedHistoryRequest.value = null;
  resultMemo.value = '';
  activeTab.value = 'pending';
};

// 다이얼로그 열릴 때 데이터 로드
watch(() => props.modelValue, (newVal) => {
  if (newVal && props.sisulCode) {
    loadRequests();
  }
});

watch(() => props.sisulCode, () => {
  if (props.modelValue && props.sisulCode) {
    loadRequests();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogVisible).value = $event)),
    "max-width": "950px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "wage-tax-res-modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("mdi-file-document-check", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[7] || (_cache[7] = _createElementVNode("h2", null, "임금신고 처리", -1)),
              _createElementVNode("p", null, _toDisplayString(__props.sisulName), 1)
            ]),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: handleClose,
              disabled: isProcessing.value
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ], 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["tab-btn", { active: activeTab.value === 'pending' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'pending'))
            }, [
              _createVNode(_component_v_icon, {
                size: "18",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("mdi-clock-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[10] || (_cache[10] = _createTextVNode(" 대기중 ", -1)),
              (pendingRequests.value.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(pendingRequests.value.length), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["tab-btn", { active: activeTab.value === 'history' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'history'))
            }, [
              _createVNode(_component_v_icon, {
                size: "18",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-history", -1)
                ]))]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createTextVNode(" 처리내역 ", -1))
            ], 2)
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "primary",
                  size: "40"
                }),
                _cache[13] || (_cache[13] = _createElementVNode("p", null, "요청 목록을 불러오는 중...", -1))
              ]))
            : (activeTab.value === 'pending')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (pendingRequests.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _cache[14] || (_cache[14] = _createElementVNode("span", null, "요청 목록", -1)),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(pendingRequests.value.length) + "건", 1)
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingRequests.value, (request) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: request.wtr_idx,
                                class: _normalizeClass(["request-row", { 'selected': selectedRequest.value?.wtr_idx === request.wtr_idx }]),
                                onClick: ($event: any) => (selectRequest(request))
                              }, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(formatYearMonth(request.wtr_leb_ym)), 1),
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(request.wtr_type), 1)
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(formatDateTime(request.wtr_requested_at)), 1),
                                  _createElementVNode("div", _hoisted_20, [
                                    (getParsedEmployees(request.wtr_new_employees).length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, " 입사 " + _toDisplayString(getParsedEmployees(request.wtr_new_employees).length), 1))
                                      : _createCommentVNode("", true),
                                    (getParsedEmployees(request.wtr_resigned_employees).length > 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, " 퇴사 " + _toDisplayString(getParsedEmployees(request.wtr_resigned_employees).length), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ], 10, _hoisted_14))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          (selectedRequest.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_24, [
                                  _cache[21] || (_cache[21] = _createElementVNode("h4", null, "요청 상세", -1)),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "귀속연월", -1)),
                                      _createElementVNode("span", _hoisted_27, _toDisplayString(formatYearMonth(selectedRequest.value.wtr_leb_ym)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "요청유형", -1)),
                                      _createElementVNode("span", _hoisted_29, _toDisplayString(selectedRequest.value.wtr_type), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "요청일시", -1)),
                                      _createElementVNode("span", _hoisted_31, _toDisplayString(formatDateTime(selectedRequest.value.wtr_requested_at)), 1)
                                    ])
                                  ]),
                                  (getParsedEmployees(selectedRequest.value.wtr_new_employees).length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "입사자", -1)),
                                        _createElementVNode("div", _hoisted_33, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getParsedEmployees(selectedRequest.value.wtr_new_employees), (emp) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: emp.emp_code,
                                              class: "emp-chip new"
                                            }, _toDisplayString(emp.emp_name), 1))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (getParsedEmployees(selectedRequest.value.wtr_resigned_employees).length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "퇴사자", -1)),
                                        _createElementVNode("div", _hoisted_35, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getParsedEmployees(selectedRequest.value.wtr_resigned_employees), (emp) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: emp.emp_code,
                                              class: "emp-chip resigned"
                                            }, _toDisplayString(emp.emp_name), 1))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (selectedRequest.value.wtr_request_memo)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "요청메모", -1)),
                                        _createElementVNode("div", _hoisted_37, _toDisplayString(selectedRequest.value.wtr_request_memo), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _cache[26] || (_cache[26] = _createElementVNode("h4", null, "처리", -1)),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createVNode(_component_v_icon, {
                                      size: "16",
                                      color: "#f59e0b"
                                    }, {
                                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                        _createTextVNode("mdi-information", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "실제 국세청 임금신고는 크롤링 기능 추가 후 자동 처리됩니다.", -1))
                                  ]),
                                  _createVNode(_component_v_textarea, {
                                    modelValue: resultMemo.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((resultMemo).value = $event)),
                                    variant: "outlined",
                                    placeholder: "결과 메모 (미승인 시 사유 필수)",
                                    rows: "2",
                                    "hide-details": "",
                                    density: "compact",
                                    class: "result-textarea"
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("button", {
                                      class: "btn-reject",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (handleProcess('미승인'))),
                                      disabled: isProcessing.value
                                    }, [
                                      (isProcessing.value && processAction.value === '미승인')
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 0,
                                            indeterminate: "",
                                            size: "14",
                                            width: "2",
                                            color: "white",
                                            class: "mr-1"
                                          }))
                                        : _createCommentVNode("", true),
                                      _cache[24] || (_cache[24] = _createTextVNode(" 미승인 ", -1))
                                    ], 8, _hoisted_41),
                                    _createElementVNode("button", {
                                      class: "btn-approve",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (handleProcess('승인'))),
                                      disabled: isProcessing.value
                                    }, [
                                      (isProcessing.value && processAction.value === '승인')
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 0,
                                            indeterminate: "",
                                            size: "14",
                                            width: "2",
                                            color: "white",
                                            class: "mr-1"
                                          }))
                                        : _createCommentVNode("", true),
                                      _cache[25] || (_cache[25] = _createTextVNode(" 승인 ", -1))
                                    ], 8, _hoisted_42)
                                  ])
                                ])
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createVNode(_component_v_icon, {
                                  size: "40",
                                  color: "#d1d5db"
                                }, {
                                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                    _createTextVNode("mdi-gesture-tap", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[28] || (_cache[28] = _createElementVNode("p", null, "요청을 선택하세요", -1))
                              ]))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createVNode(_component_v_icon, {
                          size: "56",
                          color: "#d1d5db"
                        }, {
                          default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                            _createTextVNode("mdi-check-circle-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[30] || (_cache[30] = _createElementVNode("h3", null, "대기중인 요청이 없습니다", -1)),
                        _cache[31] || (_cache[31] = _createElementVNode("p", null, "모든 임금신고 요청이 처리되었습니다", -1))
                      ]))
                ]))
              : (activeTab.value === 'history')
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    (historyRequests.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _cache[32] || (_cache[32] = _createElementVNode("span", null, "처리 내역", -1)),
                              _createElementVNode("span", _hoisted_49, _toDisplayString(historyRequests.value.length) + "건", 1)
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyRequests.value, (request) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: request.wtr_idx,
                                  class: _normalizeClass(["request-row", { 'selected': selectedHistoryRequest.value?.wtr_idx === request.wtr_idx }]),
                                  onClick: ($event: any) => (selectHistoryRequest(request))
                                }, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("span", _hoisted_53, _toDisplayString(formatYearMonth(request.wtr_leb_ym)), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["status-badge-small", getStatusClass(request.wtr_status)])
                                    }, _toDisplayString(request.wtr_status), 3)
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("span", _hoisted_55, _toDisplayString(formatDateTime(request.wtr_requested_at)), 1),
                                    _createElementVNode("div", _hoisted_56, [
                                      (getParsedEmployees(request.wtr_new_employees).length > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, " 입사 " + _toDisplayString(getParsedEmployees(request.wtr_new_employees).length), 1))
                                        : _createCommentVNode("", true),
                                      (getParsedEmployees(request.wtr_resigned_employees).length > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, " 퇴사 " + _toDisplayString(getParsedEmployees(request.wtr_resigned_employees).length), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ], 10, _hoisted_51))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            (selectedHistoryRequest.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_60, [
                                    _cache[39] || (_cache[39] = _createElementVNode("h4", null, "요청 상세", -1)),
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("div", _hoisted_62, [
                                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "귀속연월", -1)),
                                        _createElementVNode("span", _hoisted_63, _toDisplayString(formatYearMonth(selectedHistoryRequest.value.wtr_leb_ym)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_64, [
                                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "요청유형", -1)),
                                        _createElementVNode("span", _hoisted_65, _toDisplayString(selectedHistoryRequest.value.wtr_type), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_66, [
                                        _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "요청일시", -1)),
                                        _createElementVNode("span", _hoisted_67, _toDisplayString(formatDateTime(selectedHistoryRequest.value.wtr_requested_at)), 1)
                                      ])
                                    ]),
                                    (getParsedEmployees(selectedHistoryRequest.value.wtr_new_employees).length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                          _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "입사자", -1)),
                                          _createElementVNode("div", _hoisted_69, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getParsedEmployees(selectedHistoryRequest.value.wtr_new_employees), (emp) => {
                                              return (_openBlock(), _createElementBlock("span", {
                                                key: emp.emp_code,
                                                class: "emp-chip new"
                                              }, _toDisplayString(emp.emp_name), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (getParsedEmployees(selectedHistoryRequest.value.wtr_resigned_employees).length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "label" }, "퇴사자", -1)),
                                          _createElementVNode("div", _hoisted_71, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getParsedEmployees(selectedHistoryRequest.value.wtr_resigned_employees), (emp) => {
                                              return (_openBlock(), _createElementBlock("span", {
                                                key: emp.emp_code,
                                                class: "emp-chip resigned"
                                              }, _toDisplayString(emp.emp_name), 1))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (selectedHistoryRequest.value.wtr_request_memo)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "label" }, "요청메모", -1)),
                                          _createElementVNode("div", _hoisted_73, _toDisplayString(selectedHistoryRequest.value.wtr_request_memo), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["result-section", getStatusClass(selectedHistoryRequest.value.wtr_status)])
                                  }, [
                                    _createElementVNode("div", _hoisted_74, [
                                      _createVNode(_component_v_icon, {
                                        size: "20",
                                        color: getStatusIconColor(selectedHistoryRequest.value.wtr_status)
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(getStatusIcon(selectedHistoryRequest.value.wtr_status)), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color"]),
                                      _createElementVNode("h4", null, "처리 결과: " + _toDisplayString(selectedHistoryRequest.value.wtr_status), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_75, [
                                      _createElementVNode("div", _hoisted_76, [
                                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "label" }, "처리일시", -1)),
                                        _createElementVNode("span", _hoisted_77, _toDisplayString(formatDateTime(selectedHistoryRequest.value.wtr_processed_at || selectedHistoryRequest.value.wtr_cancelled_at)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_78, [
                                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "label" }, "처리자", -1)),
                                        _createElementVNode("span", _hoisted_79, _toDisplayString(selectedHistoryRequest.value.wtr_processed_by || selectedHistoryRequest.value.wtr_cancelled_by || '-'), 1)
                                      ])
                                    ]),
                                    (selectedHistoryRequest.value.wtr_result_memo || selectedHistoryRequest.value.wtr_cancel_reason)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                          _createElementVNode("span", _hoisted_81, _toDisplayString(selectedHistoryRequest.value.wtr_status === '취소' ? '취소사유' : '결과메모'), 1),
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["memo-box", getStatusClass(selectedHistoryRequest.value.wtr_status)])
                                          }, _toDisplayString(selectedHistoryRequest.value.wtr_result_memo || selectedHistoryRequest.value.wtr_cancel_reason), 3)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ], 64))
                              : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                  _createVNode(_component_v_icon, {
                                    size: "40",
                                    color: "#d1d5db"
                                  }, {
                                    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                      _createTextVNode("mdi-gesture-tap", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[43] || (_cache[43] = _createElementVNode("p", null, "처리내역을 선택하세요", -1))
                                ]))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                          _createVNode(_component_v_icon, {
                            size: "56",
                            color: "#d1d5db"
                          }, {
                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                              _createTextVNode("mdi-history", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[45] || (_cache[45] = _createElementVNode("h3", null, "처리 내역이 없습니다", -1))
                        ]))
                  ]))
                : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("button", {
              class: "btn-close",
              onClick: handleClose,
              disabled: isProcessing.value
            }, " 닫기 ", 8, _hoisted_85)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})